import { detectCountryFromIP } from '../../utils/ipDetection';
import { getCountryByCode } from '../../utils/countryCodes';

/** A phone the shopper typed, as +E.164: Arabic digits read, the country from the address when no code was typed. */
export async function normalizePhone(input) {
  const western = String(input ?? '')
    .replace(/[٠-٩]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x0660 + 48))
    .replace(/[۰-۹]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x06F0 + 48));
  const clean = western.replace(/[\s\-().]/g, '');
  if (!/^\+?\d{7,15}$/.test(clean)) return null;
  if (clean.startsWith('+')) return clean;
  try {
    const countryCode = await detectCountryFromIP();
    const country = countryCode ? getCountryByCode(countryCode) : null;
    if (country?.dialCode) return country.dialCode + (clean.startsWith('0') ? clean.slice(1) : clean);
  } catch (_) { /* fall through */ }
  return null;
}
